mutation UpdatePlotValuationSettings($input: PlotValuationSettingsInput!) {
  updatePlotValuationSettings(input: $input) {
    company {
      plotValuation {
        showInPropertyValuation
      }
    }
  }
}
